import { useAuth } from '@clerk/react'
import { useEffect, useRef } from 'react'

import { setTokenGetter } from '../api.ts'
import { initPostHog, posthogIdentify, posthogReset } from '../lib/posthog.ts'

// Mounted once near the root (see main.tsx), inside <ClerkProvider> but outside the
// router — it keeps api.ts's module-level token getter in sync with the current Clerk
// session and establishes the browser analytics identity once Clerk resolves it.
export function AuthSync() {
  const { getToken, isSignedIn, userId } = useAuth()
  const previousUserId = useRef<string | null>(null)

  useEffect(() => {
    setTokenGetter(isSignedIn ? () => getToken() : null)
    return () => setTokenGetter(null)
  }, [isSignedIn, getToken])

  // RAL-142: PostHog's own load/init is deferred off the initial render path — this just
  // schedules it (see ../lib/posthog.ts for the requestIdleCallback deferral).
  useEffect(() => {
    initPostHog()
  }, [])

  useEffect(() => {
    if (isSignedIn && userId) {
      if (previousUserId.current && previousUserId.current !== userId) {
        posthogReset()
      }
      if (previousUserId.current !== userId) {
        posthogIdentify(userId)
      }
      previousUserId.current = userId
      return
    }

    if (previousUserId.current) {
      posthogReset()
      previousUserId.current = null
    }
  }, [isSignedIn, userId])

  return null
}
